import plaintextrequest from "@/utils/plaintextrequest";
import request from "@/utils/request";

// 兑换记录
export function exchangeRecord(data) {
  return plaintextrequest({
    url: "GoldCoin/exchangeMoneyLists",
    method: "post",
    data,
  });
}

//邀请中心
export function revenueCenter(data) {
  return request({
    url: "/user/revenueCenter",
    method: "post",
    data,
  });
}

// 邀请明细
export function inviateDetail(data) {
  return plaintextrequest({
    url: "Newinvite/inviteuser",
    method: "post",
    data,
  });
}

// 收益明细
export function profitDetail(data) {
  return plaintextrequest({
    url: "Newinvite/index",
    method: "post",
    data,
  });
}
// 领取邀请奖励
export function receiveDetail(data) {
  return request({
    url: "Newinvite/add",
    method: "post",
    data,
  });
}

// 余额充值记录
export function rechargeRecord(data) {
  // console.log(data)
  return request({
    url: "pay/ptbRecord",
    method: "post",
    data,
  });
}

//超值捡漏记录
export function snatchBuyRecord(data) {
  return plaintextrequest({
    url: "/BlindBox/paylog",
    method: "post",
    data,
  });
}
//  注销账户
export function accountCancel(data) {
  return request({
    url: "/user/logoutuser",
    method: "post",
    data,
  });
}

// 省钱卡购买记录
export function getSavingCardBuyRecord(data) {
  return request({
    url: "/SavedCardBuy/SavedCardLists",
    method: "post",
    data,
  });
}

export function getSuperSavingCardBuyRecord(data) {
  return request({
    url: "/SavedCardBuy/ZjSavedCardLists",
    method: "post",
    data,
  });
}

// 省钱卡奖励领取记录
export function getSavingCardAwardRecord(data) {
  return request({
    url: "/SavedCardBuy/SavedLogLists",
    method: "post",
    data,
  });
}

export function getSuperSavingCardAwardRecord(data) {
  return request({
    url: "/SavedCardBuy/ZjSavedLogLists",
    method: "post",
    data,
  });
}

// 用户月卡状态
export function McStatus(data) {
  return request({
    url: "/Monthcard/McStatus",
    method: "post",
    data,
  });
}
// 月卡详情
export function monthCardInfo(data) {
  return request({
    url: "/pay/yuekaInfo",
    method: "post",
    data,
  });
}
// 月卡领取优惠券
export function monthCardGetCoupon(data) {
  return request({
    url: "Monthcard/getcoupon",
    method: "post",
    data,
  });
}

// 月卡账单
export function monthCardBill(data) {
  console.log(data);
  return request({
    url: "/pay/gameRecord",
    method: "post",
    data,
  });
}

// 月卡开通记录
export function monthCardRecord(data) {
  return plaintextrequest({
    url: "Monthcard/monthcardlog",
    method: "post",
    data,
  });
}
// 月卡抵扣券领取记录
export function monthCardCouponRecord(data) {
  return plaintextrequest({
    url: "Monthcard/givecardlog",
    method: "post",
    data,
  });
}
// 月卡领取余额记录
export function monthCardMoneyRecord(data) {
  return plaintextrequest({
    url: "Monthcard/givemoneylog",
    method: "post",
    data,
  });
}

// 月卡不可用游戏
export function monthCardNoGame(data) {
  return plaintextrequest({
    url: "/Monthcard/giftgamelog",
    method: "post",
    data,
  });
}
// 月卡领取余额
export function monthCardGetGivemoney(data) {
  return request({
    url: "Monthcard/getGivemoney",
    method: "post",
    data,
  });
}
